import { useFastSpring } from "features/Contexts/fastSpringContext";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function FastSpring() {
  /*   All States
   ********************************************* */
  const { subscriptionId } = useFastSpring();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = useSelector((state) => state.user);
  const { id, email, firstName, lastName, phone } = user?.userInfo
    ? user.userInfo
    : {};
  const { company } = useSelector((state) => state.company);

  const [loading, setLoading] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  /*   All Functions
   ********************************************* */
  const buyProduct = () => {
    const newProduct = {
      path: "brickcloud",
      quantity: 1,
    };

    // Create a payload with the new product
    const payload = {
      products: [newProduct],
      paymentContact: {
        email: "myname@email.com",
        firstName: "Tariq",
        lastName: "Tahir",
        phone: "123-456-7890",
        company: "My Company",
      },
    };

    // Push the payload to add the product
    if (
      typeof window !== "undefined" &&
      window.fastspring &&
      window.fastspring.builder
    ) {
      window.fastspring.builder.push(payload);
    }
  };

  const checkout = () => {
    // Check if window object is defined before using it
    if (
      typeof window !== "undefined" &&
      window.fastspring &&
      window.fastspring.builder
    ) {
      buyProduct();

      // Push the payload to add the product
      window.fastspring.builder.checkout();
    }
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    const addSubscription = async () => {
      try {
        loadingOn();
        const { data } = await API.post(
          "/auth/add-subscription",
          {
            userId: id,
            subscriptionId,
          },
          {
            headers: authHeader(),
          }
        );
        if (data?.success) {
          dispatch(
            setNotification({
              message: "Subscription added successfully!",
              type: "success",
            })
          );
          const token = data?.user?.accessToken;

          if (token) {
            localStorage.setItem("user", JSON.stringify(data?.user));
            navigate("dashboard", { replace: true });
          }
        } else if (!data?.success) {
          dispatch(
            setNotification({
              message: data?.message,
              type: "error",
            })
          );
        } else {
          alert("Something went wrong");
          dispatch(
            setNotification({
              message: "Failed to add subscription.",
              type: "error",
            })
          );
        }
        loadingOff();
      } catch (err) {
        loadingOff();
        dispatch(
          setNotification({
            message: err.message,
            type: "error",
          })
        );
      }
    };

    if (subscriptionId) {
      addSubscription();
    }
  }, [subscriptionId]);

  return (
    <div className="App">
      <h2>Subscription Details</h2>
      <small>SubId : {subscriptionId}</small>
      <div className="customer-details">
        <p>Email: {email}</p>
        <p>First Name: {firstName}</p>
        <p>Last Name: {lastName}</p>
        <p>Phone: {phone}</p>
        <p>Company: {company?.name}</p>
        <hr />
        <p>Subscription Days: 30 Days </p>
        <p>Subscription Amount: $30.00 </p>
      </div>
      <button className="btn btn-info" onClick={checkout}>
        {loading ? <Spinner /> : "Subscribe Now"}
      </button>
    </div>
  );
}
